import { useState, useContext, useEffect } from "react";
import Box from "@mui/material/Box";

// import { MediaImageUploader } from "../../../components";
import { useForm } from "react-hook-form";
import { APIContext } from "../../../store/APIStore";
import IAccount from "../../../dataProvider/interfaces/IAccount";
import { theme } from "../../../theme";
import FdTextField from "../../../components/UIComponents/TextField/FdTextfield";
import FdButton from "../../../components/UIComponents/Button/FdButton";
import FdTypography from "../../../components/UIComponents/Typography/FdTypography";
import { accountForm as classes } from "../styles";
// import { StoreContext } from "../../../store/Store";

export interface IProps {
  account?: IAccount;
  onAccountSave: Function;
  onError?: (error: string) => void;
}

const AccountForm = ({ account, onAccountSave, onError }: IProps) => {
  const [attachedImage, ] = useState<File>();
  const api = useContext(APIContext);
  // const [state] = useContext(StoreContext);

  // let submit: Function;

  const onSubmit = async (values: any) => {
    if (account) {
      updateAccount(values);
    } else {
      createAccount(values);
    }
  };

  const createAccount = async (values: any) => {
    try {
      const newAccount = (await api.accountService.createAccount({
        ...values,
      })) as any;

      if (attachedImage) {
        const imageData = (await api.fileService.uploadImageFile("accounts", {
          resourceId: newAccount.id,
          file: attachedImage,
        })) as any;

        const params = {
          image: imageData.image,
        };

        const response = await api.accountService.updateAccount(
          newAccount.id,
          params
        );
        onAccountSave(response);
      } else {
        onAccountSave(newAccount);
      }
    } catch (error: any) {
      console.log(error.response);
      onError && onError(error.response.data.message);
    }
  };

  const updateAccount = async (values: any) => {
    let userImage;
    try {
      if (account) {
        if (attachedImage) {
          const imageData = (await api.fileService.uploadImageFile("accounts", {
            resourceId: account?.id,
            file: attachedImage,
          })) as any;

          userImage = imageData.image;
        }

        const response = await api.accountService.updateAccount(account.id, {
          ...values,
          image: userImage,
        });
        onAccountSave(response);
      }
    } catch (error: any) {
      console.log(error.response);
      onError && onError(error.response.data.message);
    }
  };

  // async function validate(values: any) {
  //   if (!values.name) {
  //     return { name: "Required" };
  //   }

  //   return;
  // }

  const initialValues = {
    name: account?.name,
  };

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: initialValues,
  });
  useEffect(() => {
    if (account) {
      reset(account);
    } else {
      reset({
        name: "",
      });
    }
  }, [account, reset]);

  return (
    <Box
      sx={[
        classes.accountWrapper,
        {
          border: !account
            ? `5px solid ${theme.palette.primary.main}`
            : undefined,
        },
      ]}
    >
      <Box sx={classes.infoTitle}>
        <Box sx={classes.userImage}>
          {/* <MediaImageUploader
            onImageSelect={(file: File) => {
              setAttachedImage(file);
            }}
            imageUrl={account?.image}
          /> */}
          <FdTypography
            sx={{
              margin: "auto",
              left: "28%",
              right: 0,
              bottom: 0,
              top: "3%",
              position: "absolute",
              fontSize: 45,
            }}
            label={account?.name.slice(0, 1)?.toUpperCase()}
          />
        </Box>

        <Box textAlign="left">
          <FdTypography
            label={account ? account?.name : "New account"}
            variant="h2"
            component="h2"
            sx={{
              mb: "10px",
            }}
          />
        </Box>
      </Box>
      <Box sx={classes.infoFields}>
        <form
          id="accountForm"
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          style={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
          {/* account name */}
          <FdTextField
            register={register}
            required
            name="name"
            label="Account name"
            error={errors.name?.type === "required"}
            errorMsg={errors.name && "Required field"}
          />
          <FdButton
            // onClick={(event) => {
            //   submit(event);
            // }}
            sx={classes.saveButton}
            ButtonName="Save"
            type="submit"
          />
        </form>
      </Box>
    </Box>
  );
};

export default AccountForm;
